// extracted by mini-css-extract-plugin
export var header = "Header-module--header--a4f90";
export var logo = "Header-module--logo--c7dbc";